import React from 'react';
import { EntregaFlow } from './EntregaFlow';

/**
 * Componente principal del formulario de entregas
 * Funciona tanto en móvil como en desktop
 */
export const EntregaForm: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-6 px-4">
      <EntregaFlow />
    </div>
  );
};
